import { set as vueSet } from "vue";
import { EMPTY_KEY } from "@consts";
import { isEmpty } from "@utils";

export const state = () => ({
	tiles: [],
	triedOutWords: [],
	newKeyPressed: {},
});

export const getters = {
	getNumberOfExtraTries(state, getters, rootState) {
		// Returns the number of tried out words where at least a letter was wrong
		return state.triedOutWords.filter((entry) =>
			entry.tilesMap.includes("w")
		).length;
	},
	getNumberOfExtraTriesForLevel(state) {
		// Returns the number of tried out words for a specific level where at least a letter was wrong
		return (levelIndex) =>
			state.triedOutWords.filter(
				(entry) =>
					entry.level === levelIndex && entry.tilesMap.includes("w")
			).length;
	},
};
export const mutations = {
	resetTiles(state) {
		vueSet(state, "tiles", []);
	},
	setLevelsOfTiles(state, payload) {
		if (isEmpty(payload)) {
			state.tiles.push([]);
			return;
		}

		const wordAsArrayOfChars = payload.split("");

		// Set the letter keys
		state.tiles.push(
			...[
				wordAsArrayOfChars.map((charOfWord, charOfWordIndex) => {
					return {
						...EMPTY_KEY,
						keyFit: false,
						keyValue: charOfWord,
						keyId: charOfWordIndex,
					};
				}),
			]
		);
	},
	addTile(state, payload) {
		const firstEmptySlot = state.tiles[payload.levelIndex].findIndex(
			(element) => element.keyValue === ""
		);
		if (firstEmptySlot === -1) {
			state.tiles[payload.levelIndex].push(payload.tileInfo);
		} else {
			vueSet(
				state.tiles[payload.levelIndex],
				firstEmptySlot,
				payload.tileInfo
			);
		}
	},
	removeTile(state, payload) {
		// Remove tile is not actually deleting the object from the list. Because that will cause the list to shift. We want it replaced with an Empty tile.
		const tileToRemoveIndex = state.tiles[payload.levelIndex].findIndex(
			(element) => element.keyId === payload.tileInfo.keyId
		);
		vueSet(state.tiles[payload.levelIndex], tileToRemoveIndex, EMPTY_KEY);
	},
	shuffleTiles(state, payload) {
		function shuffleArray(array) {
			for (let i = array.length - 1; i > 0; i--) {
				const j = Math.floor(Math.random() * (i + 1));
				[array[i], array[j]] = [array[j], array[i]];
			}
			return array;
		}

		const shuffledKeys = shuffleArray(state.tiles[payload.levelIndex]);
		vueSet(state.tiles, [payload.levelIndex], shuffledKeys);
	},
	updateTile(state, payload) {
		const theTile = state.tiles[payload.levelIndex].find(
			(element) => element.keyId === payload.tileInfo.keyId
		);
		if (!isEmpty(theTile)) {
			vueSet(theTile, "keyPressed", payload.tileInfo.keyPressed);
			vueSet(theTile, "keyFit", payload.tileInfo.keyFit);
		}
	},
	updateTilesEntirely(state, payload) {
		vueSet(state, "tiles", payload);
	},
	setLevelTiles(state, payload) {
		vueSet(state.tiles, payload.levelIndex, payload.tiles);
	},
	addToTriedOutWords(state, payload) {
		state.triedOutWords.push(payload);
	},
	updateTriedOutWords(state, payload) {
		state.triedOutWords = payload;
	},
	updatedAllTilesToNotCorrect(state, payload) {
		state.tiles.map((levelTiles) =>
			levelTiles
				.filter((tile) => tile.keyFit === true && tile.keyValue !== "")
				.forEach((resetTile) => {
					resetTile.keyFit = false;
					resetTile.keyPressed = false;
				})
		);
	},
	updateNewKeyPressed(state, payload) {
		vueSet(state, "newKeyPressed", payload);
	},
};
